// PDF React View
import { useGetLinkTaxDeduct } from "hooks/taxDeduct/useTaxDeduct";
import { tableFormateDate } from "pages/DataFormatInvoice/utils";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { Col, Label, Modal, ModalBody, ModalHeader, Row } from "reactstrap";

const CompareTaxDeductDetailModal = props => {
  const { isOpen, toggle, showPdfById, dataCompare, setDataCompare } = props;

  const { mutate: mutateGetLinkTaxDeduct } = useGetLinkTaxDeduct({
    onSuccess: response => {
      const dataLink = response.data;
      console.log("🚀 ~ CompareTaxDeductDetailModal ~ data:", dataLink);
      let dataCompareFinal = dataCompare;
      if (dataCompare.isChild) {
        dataCompareFinal.rightInvoice = dataLink.map(item => {
          return {
            id: item.id,
            msctu: item.ttchung_msctu,
            khctu: item.ttchung_khctu,
            shdon: item.ttchung_shdon,
            nlap: tableFormateDate(item.ttchung_nlap),
          };
        });
      } else {
        dataCompareFinal.leftInvoice = {
          id: dataLink.id,
          msctu: dataLink.ttchung_msctu,
          khctu: dataLink.ttchung_khctu,
          shdon: dataLink.ttchung_shdon,
          nlap: tableFormateDate(dataLink.ttchung_nlap),
        };
      }
      setDataCompare(dataCompareFinal);
    },
    onError: error => {
      console.log("🚀 ~ CompareTaxDeductDetailModal ~ error:", error);
    },
  });

  useEffect(() => {
    if (isOpen) {
      console.log(
        "🚀 ~ CompareTaxDeductDetailModal ~ isOpen dataCompare:",
        dataCompare
      );
      mutateGetLinkTaxDeduct({
        id: dataCompare.currentId,
        isGetChild: dataCompare.isChild,
      });
    } else {
      setDataCompare(null);
    }
  }, [isOpen]);

  return (
    <Modal
      size="sm"
      contentClassName="confirm-modal"
      isOpen={isOpen}
      role="dialog"
      style={{ maxWidth: "80%" }}
      autoFocus={true}
      centered={true}
      className="exampleModal"
      toggle={toggle}
    >
      <div className="modal-content">
        <ModalHeader toggle={toggle}>
          <Label>Thông tin CTKT liên quan</Label>
        </ModalHeader>

        <React.Fragment>
          <ModalBody>
            <React.Fragment>
              <Row className="row-cols-1 row-cols-md-2">
                <Col
                  className="text-center text-danger"
                  style={{ borderRight: "1px solid #8080805c" }}
                >
                  <div className="text-danger font-size-16">
                    <strong>
                      CTKT bị {dataCompare?.typeChange}{" "}
                      {dataCompare?.leftInvoice?.current}
                    </strong>
                  </div>
                  <table className="table ">
                    <thead>
                      <tr className="text-danger">
                        <th scope="col">Id</th>
                        <th scope="col">Mẫu số</th>
                        <th scope="col">Ký hiệu</th>
                        <th scope="col">Số CTKT</th>
                        <th scope="col">Ghi chú</th>
                        <th scope="col">Ngày lập</th>
                        <th scope="col"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td
                          title={
                            dataCompare?.leftInvoice?.id ===
                            dataCompare?.currentId
                              ? "CTKT hiện tại"
                              : ""
                          }
                        >
                          <span
                            className={
                              dataCompare?.leftInvoice?.id ===
                              dataCompare?.currentId
                                ? "tag-chips"
                                : ""
                            }
                          >
                            {" "}
                            {dataCompare?.leftInvoice?.id}
                          </span>
                        </td>
                        <td>{dataCompare?.leftInvoice?.msctu}</td>
                        <td>{dataCompare?.leftInvoice?.khctu}</td>
                        <td>{dataCompare?.leftInvoice?.shdon}</td>
                        <td>{dataCompare?.leftInvoice?.gchu}</td>
                        <td>{dataCompare?.leftInvoice?.nlap}</td>
                        <td className="text-left">
                          {dataCompare?.leftInvoice?.id && (
                            <i
                              onClick={() => {
                                showPdfById(dataCompare.leftInvoice.id);
                              }}
                              title="Bản hiển thị"
                              style={{ cursor: "pointer" }}
                              className="bx bxs-file-pdf label-icon font-size-20"
                            />
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Col>
                <Col className="text-center">
                  <div className="text-info font-size-16">
                    <strong>
                      CTKT {dataCompare?.typeChange}
                      {dataCompare?.rightInvoice?.current}
                    </strong>
                  </div>
                  <table className="table">
                    <thead>
                      <tr className="text-info">
                        <th scope="col">Id</th>
                        <th scope="col">Mẫu số</th>
                        <th scope="col">Ký hiệu</th>
                        <th scope="col">Số CTKT</th>
                        <th scope="col">Ngày lập</th>
                        <th scope="col"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {dataCompare?.rightInvoice?.map(item => {
                        return (
                          <tr key={item?.id}>
                            <td
                              title={
                                item?.id === dataCompare?.currentId
                                  ? "CTKT hiện tại"
                                  : ""
                              }
                            >
                              <span
                                className={
                                  item?.id === dataCompare?.currentId
                                    ? "tag-chips"
                                    : ""
                                }
                              >
                                {" "}
                                {item?.id}
                              </span>
                            </td>
                            <td>{item?.msctu}</td>
                            <td>{item?.khctu}</td>
                            <td>{item?.shdon ? item?.shdon : "Chờ cấp số"}</td>
                            <td>{item?.nlap}</td>
                            <td className="text-left">
                              <i
                                onClick={() => {
                                  showPdfById(item?.id);
                                }}
                                title="Bản hiển thị"
                                style={{ cursor: "pointer" }}
                                className="bx bxs-file-pdf label-icon font-size-20"
                              />
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </Col>
              </Row>
            </React.Fragment>
          </ModalBody>
        </React.Fragment>
      </div>
    </Modal>
  );
};

CompareTaxDeductDetailModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  showPdfById: PropTypes.func,
  dataCompare: PropTypes.any,
  setDataCompare: PropTypes.any,
};

export default CompareTaxDeductDetailModal;
